import Invitations from 'containers/inviteList';
import * as CompaniesCreators from 'creators/companies';
import * as CompanyCreators from 'creators/companyJob';
import * as MusicianJobsCreators from 'creators/musicianJobs';
import CompaniesState, { ICompany } from 'interfaces/state/CompaniesState';
import State from 'interfaces/state/State';
// eslint-disable-next-line
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { userName$ } from 'selectors/auth';
import { companies$, currentCompany$ } from 'selectors/companies';
import { isLoading$ as isLoadingCompanies$ } from 'selectors/companies';
import { selectedJobsType$ } from 'selectors/companyJob';

import style from './inviteList.module.scss';

interface IStateProps {
  userName: string | null;
  companies: ICompany[];
  currentCompany: CompaniesState['currentCompany'];
  selectedJobsType: 'all' | 'deleted' | 'closed' | 'archived' | 'open';
  isLoadingCompanies: boolean;
}

interface IDispatchProps {
  fetchCompanyJobs: (status: string, company_id: number, o?: number, l?: number) => void;
  fetchAllMusicianJobs: (status: string, o?: number, l?: number) => void;
  fetchCompanyList: () => void;
}

interface IProps {
  isManager?: boolean;
}

class InviteList extends PureComponent<IStateProps & IDispatchProps & IProps> {
  public async componentDidMount() {
    const { isLoadingCompanies } = this.props;
    if (isLoadingCompanies) return;
    this.fetchInitJobs();
    this.props.fetchCompanyList();
  }

  // eslint-disable-next-line
  private fetchInitJobs = () => {
    const { fetchAllMusicianJobs, fetchCompanyJobs, isManager, companies, currentCompany, selectedJobsType } = this.props;

    if (isManager) {
      setTimeout(() => fetchAllMusicianJobs(selectedJobsType, 0, 100), 500);
    } else {
      if (this.props.companies.length > 0)
        setTimeout(() => {
          fetchCompanyJobs(selectedJobsType, currentCompany ? currentCompany.id : companies[0].id, 0, 100);
        }, 500);
    }
  };

  public componentDidUpdate(prevProps: IStateProps & IDispatchProps) {
    if (prevProps.userName && prevProps.userName !== this.props.userName) {
      this.fetchInitJobs();
    }
  }

  public render() {
    return (
      <section className={style.root}>
        <Invitations />
      </section>
    );
  }
}

const mapStateToProps = (state: State): IStateProps => {
  return {
    userName: userName$(state),
    companies: companies$(state),
    currentCompany: currentCompany$(state),
    selectedJobsType: selectedJobsType$(state),
    isLoadingCompanies: isLoadingCompanies$(state),
  };
};

const mergeProps = (stateProps: IStateProps, dispatchProps: IDispatchProps, props: IProps) => {
  return {
    ...stateProps,
    fetchCompanyJobs: dispatchProps.fetchCompanyJobs,
    fetchAllMusicianJobs: dispatchProps.fetchAllMusicianJobs,
    fetchCompanyList: dispatchProps.fetchCompanyList,
    ...props,
  };
};

export default connect(
  mapStateToProps,
  {
    fetchCompanyJobs: CompanyCreators.fetchCompanyJobs,
    fetchAllMusicianJobs: MusicianJobsCreators.fetchAllMusicianJobs,
    fetchCompanyList: CompaniesCreators.fetchCompanyList,
  },
  mergeProps
)(InviteList);
